import React, { Component } from "react";
import { withTheme } from "styled-components";
import { FormattedMessage, injectIntl } from "react-intl";
import { Table, Spin, Tooltip } from "antd";
import {
  DesktopOutlined,
  MobileOutlined,
  TabletOutlined,
  WindowsOutlined,
  AppleOutlined,
  AndroidOutlined,
  QuestionOutlined,
} from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import AppContext from "../AppContext";

class AccessHistoryTable extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      sortAscending: false,
    };
  }

  formatAccessHistory = loginHistory => {
    let aHist = [];
    let i = 0;
    loginHistory.forEach(dt => {
      aHist.push({
        ip: "--",
        os: "--",
        device: "--",
        login_timestamp: dt.login_timestamp,
        result: dt.result,
        type: dt.type,
        location: {
          city: "--",
          country: "--",
          prov: "--",
        },
        id: i,
      });
      i++;
    });
    aHist = aHist.sort((a, b) => {
      return b.login_timestamp - a.login_timestamp;
    });
    return aHist;
  };

  handleChange = (pagination, filters, sorter) => {
    if (sorter?.columnKey === "time" && sorter?.order === "ascend" && !this.state.sortAscending) {
      this.setState({ sortAscending: true });
    } else if (sorter?.columnKey === "time" && sorter?.order !== "ascend" && this.state.sortAscending) {
      this.setState({ sortAscending: false });
    }
  };

  columns = [
    {
      title: (
        <span className="tableTextImp text-capitalize">
          <FormattedMessage id="time" />
        </span>
      ),
      key: "time",
      render: (login_timestamp, record) => {
        if (record?.ip === "placeholder") {
          return (
            <div style={{ whiteSpace: "break-spaces" }}>
              <div className="fieldValue"> </div>
              <div className="fieldSubValueLight"> </div>
            </div>
          );
        } else {
          return (
            <div>
              <div className="fieldValue">
                {moment(login_timestamp).isValid() ? moment(login_timestamp).format("LL") : "--"}
              </div>
              <div className="fieldValueSub">
                {moment(login_timestamp).isValid() ? moment(login_timestamp).format("LTS") : "--"}
              </div>
            </div>
          );
        }
      },
      dataIndex: "login_timestamp",
      sorter: (a, b) => {
        if (
          (a.ip === "placeholder" && !this.state.sortAscending) ||
          (b.ip === "placeholder" && this.state.sortAscending)
        ) {
          return -1;
        }
        if (
          (b.ip === "placeholder" && !this.state.sortAscending) ||
          (a.ip === "placeholder" && this.state.sortAscending)
        ) {
          return 1;
        }
        return a.login_timestamp < b.login_timestamp;
      },
    },
    {
      title: (
        <span className="tableTextImp">
          <FormattedMessage id="Result" />
        </span>
      ),
      key: "result",
      render: (result, record) => {
        return <div className="fieldValue">{result}</div>;
      },
      dataIndex: "result",
    },
    {
      title: (
        <span className="tableTextImp">
          <FormattedMessage id="Type" />
        </span>
      ),
      key: "type",
      render: (type, record) => {
        return <div className="fieldValue">{type}</div>;
      },
      dataIndex: "type",
    },
    {
      title: (
        <span className="tableTextImp text-capitalize">
          <FormattedMessage id="location" />
        </span>
      ),
      key: "location",
      dataIndex: "location",
      render: (location, record) => {
        if (record?.ip === "placeholder") {
          return (
            <div>
              <span> </span>
              <div className="fieldSubValueLight"> </div>
            </div>
          );
        } else {
          return (
            <div>
              <span>{`${location.city}, ${location.prov}`}</span>
              <div className="fieldSubValueLight">
                <FormattedMessage id={record.ip} />
              </div>
            </div>
          );
        }
      },
    },
    {
      title: (
        <span className="tableTextImp text-capitalize">
          <FormattedMessage id="device" />
        </span>
      ),
      key: "os",
      render: (os, record) => {
        if (record?.ip === "placeholder") {
          return (
            <div className="osColumn text-capitalize">
              <div style={{ paddingRight: "10px" }}> </div>
              <div> </div>
            </div>
          );
        } else {
          return (
            <div className="osColumn text-capitalize">
              <div style={{ paddingRight: "10px" }}>
                <Tooltip title={<div className="text-capitalize">{this.props.intl.formatMessage({ id: os })}</div>}>
                  {os === "ios" || os === "macos" ? (
                    <AppleOutlined style={{ marginTop: "5px" }} />
                  ) : os === "android" ? (
                    <AndroidOutlined style={{ marginTop: "5px" }} />
                  ) : os === "windows" ? (
                    <WindowsOutlined style={{ marginTop: "5px" }} />
                  ) : os === "linux" ? (
                    <FontAwesomeIcon style={{ verticalAlign: "middle", fontSize: "1em" }} icon={["fab", "linux"]} />
                  ) : os === "ubuntu" ? (
                    <FontAwesomeIcon style={{ verticalAlign: "middle", fontSize: "1em" }} icon={["fab", "ubuntu"]} />
                  ) : (
                    <QuestionOutlined style={{ marginTop: "5px" }} />
                  )}
                </Tooltip>
              </div>
              <Tooltip
                title={<div className="text-capitalize">{this.props.intl.formatMessage({ id: record.device })}</div>}
              >
                {record.device === "desktop" ? (
                  <DesktopOutlined style={{ marginTop: "5px" }} />
                ) : record.device === "tablet" ? (
                  <TabletOutlined style={{ marginTop: "5px" }} />
                ) : record.device === "mobile" ? (
                  <MobileOutlined style={{ marginTop: "5px" }} />
                ) : (
                  <QuestionOutlined style={{ marginTop: "5px" }} />
                )}
              </Tooltip>
            </div>
          );
        }
      },
      dataIndex: "os",
    },
  ];

  render() {
    return (
      <div>
        <Spin spinning={this.props.isLoading}>
          <Table
            rowKey={record => record.id}
            columns={this.columns}
            dataSource={this.formatAccessHistory(this.props.loginHistory)}
            size="small"
            pagination={{ pageSize: 8, showSizeChanger: false }}
            onChange={(pagination, filters, sorter) => this.handleChange(pagination, filters, sorter)}
          />
        </Spin>
      </div>
    );
  }
}

export default withTheme(injectIntl(AccessHistoryTable));
